import classNames from 'classnames';
import React, { FC, memo } from 'react';
import { UnitType } from 'entities/Contract';

interface FilterOptionProps {
  label: string;
  value: UnitType;
  isActive: boolean;
  onChange: (value: UnitType) => void;
  isDisabled?: boolean;
}

export const FilterOption: FC<FilterOptionProps> = memo((props) => {
  const { label, value, isActive, onChange, isDisabled } = props;

  const switchOptionTransition = 'ease-linear duration-200';

  const handleClick = (): void => {
    value && !isDisabled && onChange(value);
  };

  return (
    <div
      className={classNames(
        'py-4 px-6 rounded-lg shrink-0',
        {
          'bg-accent cursor-default': isActive,
          'bg-secondary cursor-pointer': !isActive,
          'opacity-50 cursor-not-allowed': isDisabled,
        },
        switchOptionTransition,
      )}
      onClick={handleClick}
    >
      <div
        className={classNames(
          'font-semibold text-lg',
          { 'text-secondaryLight': isActive, 'text-primary': !isActive },
          switchOptionTransition,
        )}
      >
        {label}
      </div>
    </div>
  );
});
